const getSMSStatus = (messageType) => messageType?.[0]?.Status || false;

const getSMSCount = (messageType) => messageType?.length || 0;

const getAutomaticSMSStatus = (messageType) => messageType?.length && !messageType[0]?.Status;

const verifyMessageSent = (messageType) => messageType?.[0]?.Message || false;

const stillSendSms = (type, workOrder, globalBeback) => {
  let sent = true;
  
  if(!workOrder.SmsData)
    return sent;

  switch (type) {
    case 'ready':
      if (verifyMessageSent(workOrder.SmsData.vehicleReadyMessage)) {
        sent = false;
      }
      break;
    case 'beback': 
      if ((globalBeback || workOrder.IsMarshal) && verifyMessageSent(workOrder.SmsData.beBackMessage)) {
        sent = false;
      }
      break;
    case 'call': 
      if (verifyMessageSent(workOrder.SmsData.callStoreMessage)) {
        sent = false;
      }
      break;
    case 'promisedTime': 
      if (verifyMessageSent(workOrder.SmsData.promisedTimeMessage) || verifyMessageSent(workOrder.SmsData.promisedTimeMessageUpdate)) {
        sent = false;
      }
      break;
    default:
      sent = true;
  }
  return sent;
}

const sortMessagesByTimestamp = (array) => {
  if(!array?.length) return [];
  return array.sort((a, b) => a['Timestamp'].localeCompare(b['Timestamp']));
}

const verifySendingSMS = (sendingSMS, type, WO) => {
  return sendingSMS?.some(sending => sending.wo === WO && sending.messageType === type);
}

export {
  getSMSStatus,
  getSMSCount,
  getAutomaticSMSStatus,
  verifyMessageSent,
  stillSendSms,
  sortMessagesByTimestamp,
  verifySendingSMS
}